// import { format } from 'date-fns'
// import supportedLocales from './supportedLocales'
import {
  enUS,
  de,
  es,
  it,
  fr,
  ja,
  ko,
  pt,
  ru,
  zhTW,
  bg,
  cs,
  da,
  fi,
  hu,
  id,
  km,
  mn,
  nl,
  nn,
  pl,
  ro,
  sk,
  // sm, // not in CLDR
  sq,
  sv,
  th,
  // to,
  vi,
  zhCN,
  el,
  et,
  // fj, // not in CLDR
  hr,
  ht,
  hy,
  is,
  lt,
  lv,
  mk,
  ms,
  sl,
  sr,
  tr,
  uk,
  ar,
  faIR,
  ka,
  eo,
} from 'date-fns/locale'

// import partial locales here. As these are fully implemented and merged into the date-fns project, remove from below and add above.
import { ceb, fil, fj, gn, mg, sm, sw, to, ur } from './date-fns-locale-alpha'

const dateFnsLocales = {
  en: enUS,
  de,
  es,
  it,
  fr,
  ja,
  ko,
  pt,
  ru,
  zh: zhTW,
  bg,
  ceb,
  cs,
  da,
  fi,
  hu,
  id,
  km,
  mg,
  mn,
  nl,
  no: nn,
  pl,
  ro,
  sk,
  sm,
  sq,
  sv,
  th,
  tl: fil, // tl does not have CLDR data but fil (Filipino) does and should be close enough for date formatting (even ceb looks similar for dates)
  to,
  vi,
  'zh-hans': zhCN,
  el,
  et,
  fj,
  hr,
  ht,
  hy,
  is,
  lt,
  lv,
  mk,
  ms,
  sl,
  sr,
  tr,
  uk,
  ar,
  fa: faIR,
  ka,
  sw,
  ur,
  gn,
  eo,
}

export default function getDateFnsLocale(locale) {
  return dateFnsLocales[locale] || dateFnsLocales.en
}
